/**
 * Апи для обработки ошибок
 */
export default class ErrorApi
{
    public readonly ERROR_VALIDATION = 1;
}
